import { call, put, takeLatest } from "redux-saga/effects";

import { ApiService } from "pwapi";

import {
  MESSAGES_REQUEST,
  MESSAGES_SUCCESS,
  MESSAGES_FAILURE,
} from "../actions/constants";

function* fetchMessages(action: any): any {
  try {
    const result = yield call(ApiService.listViewerMaintenanceMessages, {
      application: action.payload,
    });
    yield put({ type: MESSAGES_SUCCESS, payload: result.results });
  } catch (e) {
    yield put({
      type: MESSAGES_FAILURE,
      error: true,
      payload: e,
    });
  }
}

export function* messagesSaga() {
  yield takeLatest(MESSAGES_REQUEST, fetchMessages);
}
